<template>
  <div>
    <div class="flex cursor-pointer" @click="onClick">
      <slot> {{ defaultLabel }} <app-icon icon="ph:info" :size="18" /> </slot>
    </div>

    <lazy-place-overview-dialog
      v-if="isModalOpen"
      v-model="isModalOpen"
      :place="place"
    />
  </div>
</template>

<script lang="ts" setup>
defineOptions({ inheritAttrs: false });

const properties = defineProps<{
  place: DatabaseTable<"places">;
}>();

const [isModalOpen, toggleModal] = useToggle();
const { $analytics } = useNuxtApp();

const defaultLabel = computed(() => {
  const street = `${properties.place.address.street_number} ${properties.place.address.street}`;
  const city = properties.place.address.city;
  const zipCode = properties.place.address.zip_code;

  return `${street}, ${zipCode} ${city}`;
});

const onClick = () => {
  $analytics.track("place_dialog_viewed");
  toggleModal(true);
};
</script>
